import React from "react";
import { useAppSelector } from "../app/hooks";
import CreateMenu from "./menu/CreateMenu";
import AppDrawer from "../components/drawer/Drawer";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateSetting from "./setting/CreateSetting";
import CreateRights from "./rights/CreateRights";
import CreateFacility from "./facility/CreateFacility";
import CreateWhyChoose from "./whychoose/CreateWhyChoose";
import CreateAmenities from "./amenities/CreateAmenities";
import CreateTourType from "./tourtype/CreateTourType";
import CreateGallery from "./gallery/CreateGallery";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    menuForm: <CreateMenu />,
    testimonialForm: <CreateTestimonial />,
    settingForm: <CreateSetting />,
    rightsForm: <CreateRights />,
    facilityForm: <CreateFacility />,
    whychooseForm: <CreateWhyChoose />,
    amenitiesForm: <CreateAmenities />,
    tourtypeForm: <CreateTourType />,
    galleryForm: <CreateGallery />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
